import React, { Component } from "react";
import axios from "axios";
import { Image, Form, Modal } from "react-bootstrap";
import classnames from "classnames";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
// import "react-responsive-modal/styles.css";
import {
  IconButtonReusableComponent,
  PopupActionButton,
} from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import {
  InputBoxComponent,
  NewInputText,
  SelectBoxCategoryMui,
  SelectCategory,
} from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";

import { serverApi } from "../../../../../config/Keys";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { MobileNumberValidation } from "../../../../../store/validation/allValidationFile/authenticationValidation/MobileNumberValidation";
import {
  superadmin_referrals_main_add,
  superadmin_refree_get_with_mobile_number,
  superadmin_refrrals_get,
} from "../../../../../store/actions/SuperAdminActions/superadminreferralsaction";
import Alert from "react-s-alert";

class AddReferralsPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      referralName: "",
      referralEmail: "",
      country_code: "+91",
      mobile_number: "",
      referral_number: "",
      allcategory: [
        { id: 1, category_name: "Sales person" },
        { id: 2, category_name: "Affiliate" },
        { id: 3, category_name: "Partners" },
      ],
      referralcategories: [
        { id: 1, category_name: "Vendor" },
        { id: 2, category_name: "User" },
      ],
      category: "",
      referralcategory: "",
      referralCode: "",
      referee_mobile_number: "",
      referee_country_code: "+91",
      referee: {},
      addIcon: "",
      errors: [],
      logo_url: "",
      logo_main: null,
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          referee_country_code: result.data.country_calling_code,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    return null;
  }

  onChange = (e) => {
    const { value } = e.target;
    this.setState({
      [e.target.name]: value,
      errors: {},
    });
    if (
      e.target.name === "referee_mobile_number" &&
      e.target.value.toString().length === 10 &&
      this.state.referee_country_code
    ) {
      this.getRefreesOfMobileNumber(e.target.value);
    } else if (
      e.target.name === "referralcategory" &&
      this.state.referral_number.toString().length === 10 &&
      this.state.country_code
    ) {
      this.getReferralsOfMobileNumber(
        this.state.referral_number,
        e.target.value
      );
    } else {
      if (e.target.name === "referee_mobile_number") {
        this.setState({ referee: {}, category: "", referralCode: "" });
      } else if (e.target.name === "referral_number") {
        this.setState({
          referrals: {},
          referralName: "",
          referralcategory: "",
        });
      }
    }
  };

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/
  onImageLogoUploadHandler = (e) => {
    this.setState({ loader: true });
    const data = new FormData();
    data.append("image", e.target.files[0]);
    axios
      .post(`${serverApi}/image/upload-content-images`, data)
      .then((res) => {
        this.setState({ addIcon: res.data.image_URL, loader: false });
      })
      .catch((err) => {
        this.setState({ loader: false });
        window.alert("Error while uploading the image");
      });
  };

  handleSubmit = (e) => {
    this.props.clear_all_errors();
    e.preventDefault();
    const { errors } = this.state;
    this.setState({
      errors: {},
    });
    if (!this.state.referee_mobile_number.length === 10) {
      this.setState({
        errors: { referee_mobile_number: "Enter a refree mobile number" },
      });
    } else if (!this.state.referral_number) {
      this.setState({
        errors: { referral_number: "Enter a referral mobile number" },
      });
    } else if (!this.state.referee) {
      this.setState({
        errors: { referee: "Enter a referee mobile number" },
      });
    } else if (!this.state.referralName) {
      this.setState({
        errors: { referralName: "Enter a referral mobile number" },
      });
    } else {
      const token = this.props.auth.user.accessToken;
      const formData = {
        referred_user_name: this.state.referralName,
        referred_user_country_code: this.state.country_code,
        referred_user_mobile_number: this.state.referral_number,
        referee_name: this.state.referee.name,
        referee_country_code: this.state.referee_country_code,
        referee_mobile_number: this.state.referee_mobile_number,
        referee_role: this.state.category,
        // active_from: "2021-03-22T11:39:14.903+00:00",
        // expire_at: "2021-12-22T18:30:00.000+00:00",
        active: "true",
        referral_code: this.state.referee.referral_code,
      };
      console.log(formData);
      this.props.superadmin_referrals_main_add(
        formData,
        token,
        () => {
          this.onCloseModal();
          this.props.superadmin_refrrals_get(token, "USER");
          Alert.success(`<h4>Referee added successfully.</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        },
        (err) => {
          Alert.error(`<h4>${err.message}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        }
      );
    }
  };
  getRefreesOfMobileNumber = (number) => {
    const token = this.props.auth.user.accessToken;
    this.props.superadmin_refree_get_with_mobile_number(
      token,
      this.state.referee_country_code,
      number,
      "Refree",
      (e) => {
        this.setState({
          referee: e,
          category: e.role,
          referralCode: e.referral_code,
        });
      },
      (err) => {
        Alert.error(`<h4>${err.message}</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    );
  };
  getReferralsOfMobileNumber = (number, referralcategory) => {
    const token = this.props.auth.user.accessToken;
    this.props.superadmin_refree_get_with_mobile_number(
      token,
      this.state.country_code,
      number,
      referralcategory,
      (e) => {
        if (referralcategory === "Vendor") {
          this.setState({
            referrals: e,
            referralName: e?.email?.split("@")[0],
          });
        } else {
          this.setState({
            referrals: e,
            referralName: e.name ? e.name : e.first_name + e.last_name,
          });
        }
      },
      (err) => {
        Alert.error(`<h4>${err.message}</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    );
  };
  render() {
    const { open, errors, referee } = this.state;
    return (
      <React.Fragment>
        {this.props.source && this.props.source === "allrefs" ? (
          <>
            <button
              type="button"
              class="mr-4 px-5 py-2 btn btn-outline-secondary"
              onClick={this.onOpenModal}
            >
              Add Referral
            </button>
          </>
        ) : (
          <>
            {this.props.withIcon ? (
              <div className="super-admin-icon-box-width">
                <Image
                  src={
                    !this.props.src
                      ? require("../../../../../assets/images/OfferAndEventImages/edit.png")
                      : require("../../../../../assets/images/OfferAndEventImages/view.png")
                  }
                  alt="View Icon"
                  title="View Profile"
                  fluid
                  onClick={this.onOpenModal}
                />
              </div>
            ) : (
              <button
                onClick={this.onOpenModal}
                className="btn add_button_custom_1"
              >
                + Add Referral Code
              </button>
            )}
          </>
        )}
        {/* <IconButtonReusableComponent
          buttonText="Add Referral Code"
          onClick={this.onOpenModal}
          buttonType="button"
        /> */}
        <Modal show={open} onHide={this.onCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.withIcon ? "Edit" : "Add"} Referral
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="add-referral-section-body p-3">
              <Form noValidate onSubmit={this.handleSubmit}>
                <Form.Row className="input-component-insideRow">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 pr-0">
                    <Form.Group
                      className="reusableInputComponent-main mb-0"
                      controlId={"referee_country_code"}
                    >
                      <Form.Label className="d-flex input-component-labeltext mt-3">
                        Referee Number
                      </Form.Label>
                      <div className="input-phone-country-code-reusable">
                        <select
                          name="referee_country_code"
                          value={this.state.referee_country_code}
                          onChange={this.onChange}
                        >
                          <option value={this.state.referee_country_code}>
                            {this.state.referee_country_code}
                          </option>
                          {getCountries().map((country) => (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+{getCountryCallingCode(country)})
                            </option>
                          ))}
                        </select>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 pl-0 mt-5">
                    <NewInputText
                      displayLabel={"displayLabelNone"}
                      controlId="referee_mobile_number"
                      labelText="Phone Number"
                      inputType="number"
                      placeHolder="Enter mobile number"
                      name="referee_mobile_number"
                      onChange={this.onChange}
                      value={this.state.referee_mobile_number}
                      required="required"
                      showBottom={true}
                      error={errors.referee_mobile_number}
                      inputClassName={classnames(
                        "input-component-inputfield input-field-referrals-code-margin",
                        {
                          invalid: errors.referee_mobile_number,
                        }
                      )}
                    />
                    <div style={{ color: "red" }}>
                      {errors.referee_mobile_number &&
                        errors.referee_mobile_number}
                    </div>
                  </div>
                </Form.Row>

                {/* <SelectBoxCategoryMui
                  controlId={"category"}
                  getData={this.state.allcategory.map(
                    (data) => data.category_name
                  )}
                  inputlabelclass="input-component-labeltext mt-3"
                  selectLabel="Select Refree Role"
                  name="category"
                  value={this.state.category}
                  onChange={this.onChange}
                  error={errors.category}
                  inputClass={classnames("input-component-inputfield w-100", {
                    invalid: errors.category,
                  })}
                /> */}
                <div className="display-referral-image-text d-flex">
                  <div className="profile-image-box">
                    <Image
                      src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                      fluid
                      className="rounded-circle"
                      style={{ maxWidth: "100px" }}
                      alt="profile"
                      title="Referee Profile"
                    />
                  </div>
                  <div className="w-100">
                    <div className="d-flex p-4 justify-content-between">
                      <div>
                        <h5>Referree Name</h5>
                        <h6>{referee && referee.name}</h6>
                      </div>
                      <div>
                        <h5>Referree Role</h5>
                        <h6>{referee && referee.role}</h6>
                      </div>
                    </div>
                  </div>
                </div>

                <Form.Row className="input-component-insideRow">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 pr-0">
                    <Form.Group
                      className="reusableInputComponent-main mb-0"
                      controlId={"country_code"}
                    >
                      <Form.Label className="d-flex input-component-labeltext mt-3">
                        Referral Phone Number
                      </Form.Label>
                      <div className="input-phone-country-code-reusable">
                        <select
                          name="country_code"
                          value={this.state.country_code}
                          onChange={this.onChange}
                        >
                          <option value={this.state.country_code}>
                            {this.state.country_code}
                          </option>
                          {getCountries().map((country) => (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+{getCountryCallingCode(country)})
                            </option>
                          ))}
                        </select>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 pl-0 mt-5">
                    <NewInputText
                      displayLabel={"displayLabelNone"}
                      controlId="referral_number"
                      labelText="Mobile Number"
                      inputType="number"
                      placeHolder="Referral Mobile Number"
                      name="referral_number"
                      onChange={this.onChange}
                      value={this.state.referral_number}
                      required="required"
                      showBottom={true}
                      error={errors.referral_number}
                      inputClassName={classnames(
                        "input-component-inputfield input-field-referrals-code-margin",
                        {
                          invalid: errors.referral_number,
                        }
                      )}
                    />
                  </div>
                </Form.Row>
                <div style={{ color: "red" }}>
                  {errors.referral_number && errors.referral_number}
                </div>
                <SelectBoxCategoryMui
                  controlId={"referralcategory"}
                  getData={this.state.referralcategories.map(
                    (data) => data.category_name
                  )}
                  inputlabelclass="input-component-labeltext mt-3"
                  selectLabel="Select Referral Role"
                  name="referralcategory"
                  value={this.state.referralcategory}
                  onChange={this.onChange}
                  error={errors.referralcategory}
                  inputClass={classnames("input-component-inputfield w-100", {
                    invalid: errors.referralcategory,
                  })}
                />
                <div style={{ color: "red" }}>
                  {errors.referralcategory && errors.referralcategory}
                </div>
                <NewInputText
                  displayLabel={true}
                  controlId="referralName"
                  labelText="Referral User Name"
                  inputType="text"
                  placeHolder="Ram Kumar Sharma"
                  name="referralName"
                  onChange={this.onChange}
                  value={this.state.referralName}
                  required="required"
                  disabled
                  showBottom={true}
                  error={errors.referralName}
                  inputClassName={classnames("input-component-inputfield", {
                    invalid: errors.referralName,
                  })}
                />
                <div style={{ color: "red" }}>
                  {errors.referralName && errors.referralName}
                </div>
                <NewInputText
                  displayLabel={true}
                  controlId="referralCode"
                  labelText="Referral Code"
                  inputType="text"
                  placeHolder=""
                  name="referralCode"
                  onChange={this.onChange}
                  value={this.state.referralCode}
                  disabled
                  required="required"
                  showBottom={true}
                  error={errors.referralCsode}
                  inputClassName={classnames("input-component-inputfield", {
                    invalid: errors.referralCode,
                  })}
                />
                <div style={{ color: "red" }}>
                  {errors.referralCsode && errors.referralCsode}
                </div>
                <div className="row justify-content-end position-relative">
                  <div className="col-12 bottom-button d-flex justify-content-between mt-4 mb-4 add-diner-floating-button">
                    <div className="margin-seating-left">
                      <PopupActionButton
                        buttonText="Cancel"
                        buttonType="button"
                        buttonClass="bigbuttongray"
                        onClick={this.onCloseModal}
                      />
                    </div>
                    <PopupActionButton
                      buttonText="Send Invite"
                      buttonType="submit"
                      buttonClass="bigbuttonred"
                    />
                  </div>
                </div>
              </Form>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

AddReferralsPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_referrals_main_add,
  superadmin_refree_get_with_mobile_number,
  superadmin_refrrals_get,
})(withRouter(AddReferralsPopup));
